<template>
    <a-card :bordered="false">  
        <!-- Search Bar -->
        <a-row :gutter="24" style="margin-bottom: 16px;">
            <a-col :span="6">
                <div class="form-item">
                    <span class="form-label">{{ $t('investorList.qsrzh') }}:</span>
                    <a-input v-model="queryParam.mobile" :placeholder="$t('investorList.qsrzh')" style="width: 100%"
                        @pressEnter="searchQuery" />
                </div>
            </a-col>
            <a-col :span="12" style="text-align: left;">
                <a-button style="margin-right: 8px;" @click="searchReset">{{ $t('reset') }}</a-button>
                <a-button type="primary" @click="searchQuery">{{ $t('search') }}</a-button>
            </a-col>
            <a-col :span="6" style="text-align: right;">
                <a-button type="primary" @click="showCreateModal" icon="plus">
                    {{ $t('investorList.cjcz') }}
                </a-button>
            </a-col>
        </a-row>

        <!-- Data Table -->
        <a-table :columns="columns" :data-source="dataSource" :pagination="pagination" :loading="loading" bordered
            rowKey="id" @change="handleTableChange" />

        <!-- Create Recharge Modal -->
        <a-modal :title="$t('investorList.cjcz')" :visible="createModalVisible" :confirm-loading="createLoading" @ok="handleCreate"
            @cancel="handleCancelCreate">
            <a-form :form="createForm" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
                <a-form-item :label="$t('investorList.czzh')" required>
                    <a-input v-decorator="[
                        'mobile',
                        {
                            rules: [
                                { required: true, message: $t('investorList.qsryhsjh') },
                                { pattern: /^[0-9]+$/, message: $t('investorList.qsryhsjh') }
                            ]
                        }
                    ]" :placeholder="$t('investorList.czzh')" />
                </a-form-item>
                <a-form-item :label="$t('investorList.czje')" required>
                    <a-input-number v-decorator="[
                        'amount',
                        {
                            rules: [
                                { required: true, message: $t('investorList.qsrczje') },
                                { type: 'number', min: 1, message: $t('investorList.qsrczje') }
                            ]
                        }
                    ]" :placeholder="$t('investorList.qsrczje')" :min="1" :precision="0" style="width: 100%" />
                </a-form-item>
                <a-form-item :label="$t('remark')" required>
                    <a-input v-decorator="[
                        'remark',
                        {
                            rules: [
                                { required: true, message: $t('investorList.qsrbz') }
                            ]
                        }
                    ]" :placeholder="$t('investorList.qsrbz')" />
                </a-form-item>
            </a-form>
        </a-modal>
    </a-card>
</template>

<script>
import { getChargeList, createCharge } from '@/webpublicapi/vietnamBackstage'
import moment from 'moment'

export default {
    name: 'AccountTop',
    data() {
        return {
            dataSource: [],
            loading: false,
            queryParam: {
                mobile: '',
            },
            pagination: {
                current: 1,
                pageSize: 10,
                total: 0,
                showSizeChanger: true,
                showTotal: (total) => `${this.$t('components.total')} ${total} ${this.$t('components.items')}`,
                pageSizeOptions: ['10', '20', '50', '100'],
            },
            createModalVisible: false,
            createLoading: false,
            createForm: this.$form.createForm(this),
        }
    },
    computed: {
        columns() {
            return [
                {
                    title: this.$t('investorList.czzh'),
                    dataIndex: 'mobile',
                    align: 'left',
                },
                {
                    title: this.$t('investorList.czje'),
                    dataIndex: 'amount',
                    align: 'right',
                    className: 'amount-column',
                    customRender: (text) => (text === 0 ? 0 : (text || '--'))
                },
                {
                    title: this.$t('investorList.czrq'),
                    dataIndex: 'chargeDate',
                    align: 'left',
                    customRender: (text) => text ? moment(text).format('DD-MM-YYYY HH:mm:ss') : '--',
                },
                {
                    title: this.$t('investorList.czr'),
                    dataIndex: 'chargeBy',
                    align: 'left',
                },
                {
                    title: this.$t('remark'),
                    dataIndex: 'remark',
                    align: 'left',
                }
            ]
        }
    },
    created() {
        this.loadData()
    },
    methods: {
        extractList(respData = {}) {
            return respData.list || respData.records || respData.data || []
        },
        async loadData() {
            this.loading = true
            const { current, pageSize } = this.pagination
            const params = { pageNo: current, pageSize, type: 1 }
            if (this.queryParam.mobile) {
                params.mobile = this.queryParam.mobile
            }

            try {
                const res = await getChargeList(params)
                if (res.success) {
                    const respData = res.respData || {}
                    this.dataSource = this.extractList(respData)
                    this.pagination.total = respData.total || 0
                } else {
                    this.$message.error(res.respMsg || this.$t('platformCollection.failed_to_get_data'))
                }
            } catch (error) {
                this.$message.error(this.$t('platformCollection.failed_to_get_data'))
                console.error(error)
            } finally {
                this.loading = false
            }
        },
        searchQuery() {
            this.pagination.current = 1
            this.loadData()
        },
        searchReset() {
            this.queryParam = { mobile: '' }
            this.searchQuery()
        },
        handleTableChange(pagination) {
            this.pagination.current = pagination.current
            this.pagination.pageSize = pagination.pageSize
            this.loadData()
        },
        showCreateModal() {
            this.createModalVisible = true
            this.createForm.resetFields()
        },
        handleCancelCreate() {
            this.createModalVisible = false
            this.createForm.resetFields()
        },
        validateCreateForm() {
            return new Promise((resolve, reject) => {
                this.createForm.validateFields((err, values) => {
                    if (err) return reject(err)
                    resolve(values)
                })
            })
        },
        async handleCreate() {
            try {
                const values = await this.validateCreateForm()
                this.createLoading = true
                const res = await createCharge({
                    mobile: values.mobile,
                    amount: values.amount,
                    remark: values.remark
                })

                if (res.success) {
                    this.$message.success(res.respMsg || this.$t('investorList.cg'))
                    this.createModalVisible = false
                    this.createForm.resetFields()
                    this.loadData()
                } else {
                    this.$message.error(res.respMsg || this.$t('investorList.sb'))
                }
            } catch (error) {
                // Form validation failed, interrupt directly, other exceptions
                if (error && error.errorFields) return
                this.$message.error(this.$t('investorList.sb'))
                console.error(error)
            } finally {
                this.createLoading = false
            }
        }
    },
}
</script>

<style lang="less" scoped>
@import '~@/assets/less/common.less';

.form-item {
    display: flex;
    align-items: center;
    gap: 8px;

    .form-label {
        min-width: 100px;
        text-align: right;
        white-space: nowrap;
        flex-shrink: 0;
    }

    :deep(.ant-input),
    :deep(.ant-select) {
        flex: 1;
    }
}
</style>